"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG = void 0;
// NON VARIARE MAI QUESTA CONFIGURAZIONE
const baseInformations = {
    url_mock: "http://demo6342644.mockable.io",
    url_json_config: "/web/commons/config/network.config.json",
    url: "",
    url_priv: "/api/priv/",
    url_pub: "/api/pub/",
    url_sia: "/tpdsia/rest/",
    "x-ibm-client-id": "",
    "x-ibm-client-secret": "",
    apiKey: "",
    "user-context": "userContext/v1/users",
    crm: "crm/users/v1/", // myDetails
};
// NON VARIARE MAI QUESTA CONFIGURAZIONE
const prodConfiguration = {
    baseInformations,
    gk: "AIzaSyBtyrWVTTVxJSzkvwPNOeOY0uUrDtivB48",
    MOCK: false,
    LOCALHOSTURLS: false,
    LOCALSERVICES: false,
    READ_CONFIG_FROM_SERVER: true,
    VERBOSE: false,
    PROD_MODE: true,
};
const baseConfig = prodConfiguration;
exports.CONFIG = {
    baseInformations: baseConfig.baseInformations,
    gk: baseConfig.gk,
    MOCK: baseConfig.MOCK,
    LOCALHOSTURLS: baseConfig.LOCALHOSTURLS,
    LOCALSERVICES: baseConfig.LOCALSERVICES,
    READ_CONFIG_FROM_SERVER: baseConfig.READ_CONFIG_FROM_SERVER,
    VERBOSE: baseConfig.VERBOSE,
    PROD_MODE: baseConfig.PROD_MODE,
    // TODO TPDANGULARLIB DA SISTEMARE
    // getGk(): any {
    //   // se sviluppo locale, imposto da CONFG
    //   if (!baseConfig.READ_CONFIG_FROM_SERVER) {
    //     if (baseConfig.baseInformations.apiKey != "") {
    //       return baseConfig.baseInformations["apiKey"];
    //     } else {
    //       return baseConfig.gk ? baseConfig.gk : "";
    //     }
    //   }
    //   // se sviluppo da server provo a recuperare la chiave dal file Unipol
    //   else {
    //     // rieseguo la chiamata solo se una o entrambe le chiavi non sono ancora state definite
    //     if (
    //       this.clientId == null ||
    //       this.clientId == undefined ||
    //       this.clientSecret == null ||
    //       this.clientSecret == undefined
    //     ) {
    //       let apiKey = "";
    //       // chiamata al server per il recupero del json di configurazione
    //       ajax({
    //         url: baseConfig.baseInformations.url_json_config,
    //         method: "GET",
    //         timeout: 5000, // 5 secondi per il recupero
    //         async: false, // chiamata necessariamente sincrona
    //       }).subscribe({
    //         next: (ajaxResponse: any) => {
    //           const response = ajaxResponse.response;
    //           apiKey = response.apiKey;
    //         },
    //         error: () => (apiKey = ""),
    //       });
    //       return apiKey;
    //     }
    //   }
    // },
};
